import  * as React from "react";
import { AppCtxProvider } from "./app_context";
import { TProviderProps, TProviderState } from "Portal/mixin/types";
import { Badge } from "deda-rkit";


export default class AppProvider extends React.Component<TProviderProps,TProviderState>{
    // state = {
    //     scene: {}
    //     }
   
  

    constructor(props){
      super(props);
      //this.state = this.state;
    }

    render() {
        return (
            <AppCtxProvider value={this.props.context} >
                {this.props.children}
            </AppCtxProvider>
        );
    }
};

// Questa funzione aggiunge l'elemento badge per i link Notifiche e Comunicazioni se ce ne sono da leggere
export const aggiungiElementoBageHeaderLinks = (headerLinks , notificheDaLeggere, comunicazioniDaLeggere) => {
  return headerLinks.map((link) => {

    // Se è presente una chiave id in configurazione per questo header links, fornisco l'elemento con il badge degli elementi ancora da leggere
    if (link.id) {
      if (link.id == 'notifiche' && notificheDaLeggere > 0) {

        link.element = <>{link.label}<Badge className='bg-light mx-1 text-primary' >{ notificheDaLeggere }</Badge></>
      }
      if (link.id == 'comunicazioni' && comunicazioniDaLeggere > 0) {
        link.element = <>{link.label}<Badge className='bg-light mx-1 text-primary' >{ comunicazioniDaLeggere }</Badge></>
      }
    }
    return link
  })
}